<template>
    <div id="ReceiptList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Receipt List</div>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- Button for Clear Cache -->
                        <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="canAdd" class="btn btn-secondary" v-bind:to="{name: 'ReceiptInvoiceMapper'}" > Map Invoice</router-link>
                        <router-link v-if="canAdd" class="btn btn-primary" v-bind:to="{name: 'ReceiptItemList'}" > Receipt Item</router-link>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal" >
                            <i class="fp-import"></i> Import
                        </a>
                        <router-link v-if="canAdd" class="btn btn-primary" v-bind:to="{name: 'ReceiptCreate'}" > <i class="fp-add"> </i> Add</router-link>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="true" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul class="m-0">
                                <li><a href="javascript:void(0)" class="" v-on:click="exportReports()">Export</a></li>
                                <li><router-link v-if="canAdd" class="" v-bind:to="{name: 'ReceiptInvoiceMapper'}" > Map Invoice</router-link></li>
                                <li><router-link v-if="canAdd" class="" v-bind:to="{name: 'ReceiptItemList'}" > Receipt Item</router-link></li>
                                <li><a href="javascript:void(0)" class="" v-on:click="openModal" >Import</a></li>
                                <li><router-link v-if="canAdd" class="" v-bind:to="{name: 'ReceiptCreate'}" >  Add</router-link></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content receipt-list">
                        <data-table-filter-config :moduleName="'receiptList'" @cancelSelection="cancelAll"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'receiptList'" :position="'top'">
                                </custom-pagination>

                                <vue-good-table
                                    ref="listReceiptTable"
                                    mode="remote"
                                    title="News"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdate">
                                                    <router-link title="Edit Receipt" class="fp-edit" v-bind:to="{name: 'ReceiptEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                        <div class="modal fade invoice-modal update-reading-modal" id="receiptModal" ref="receiptModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importFile" class="addinspectionForm basic-form-container">
                                            <div class="form-row">
                                                <div class="col-md-12 form-group mb-4">
                                                    <label class="control-label require w-100" for="name">File:</label>
                                                    <input id="typeImage" type="file" @change="onFileChanged">
                                                </div>
                                                <div class="" v-if="selectFile != ''">
                                                    <label class="control-label"> Download Sample file for Receipt </label>
                                                    <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{selectFile}} </a>
                                                </div>
                                                <div class="col-md-12 form-group">
                                                    <div class="custom-checkbox">
                                                        <label class="checkbox-custom">  LockBox <input type="checkbox" @input="changeLockCheck($event)" v-model="lockbox" id="lockbox" name="lockbox">
                                                        <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col form-group" v-if="lockbox">
                                                    <label class="control-label" for="reason">Receipt:</label>
                                                    <v-select v-model="receipt" name="receipt" placeholder="Select Receipt." label="text" :options="receiptArr" class="close-remove"></v-select>
                                                    <div class="field-error">{{receiptErrorMsg}}</div>
                                                </div>

                                                <strong id="errorMsg" class="field-error">{{errorMsg}}</strong>

                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer btm-action-btn-fl">
                                        <button class="btn btn-primary" id="myButton" v-on:click="importReport()"> <i class="fp-import"> </i> Import</button>
                                        <button type="button" class="btn btn-tertiary" data-dismiss="modal"> <i class="fp-close"> </i> Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "./event-bus";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ReceiptList",
        metaInfo() {
            return {
                title:"Receipt List | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins,contractMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    hidden:false,
                    sortable: false,
                },
                {
                    label: '# Receipt',
                    field: 'receipt_number',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Receipt", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Receipt Date',
                    field: 'receipt_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Deposit Date',
                    field: 'deposit_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Bank',
                    field: 'bank',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Receipt Amount',
                    field: 'receipt_amount',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Settled Amount',
                    field: 'mapped_amount',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    type: 'number',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable: false,
                },
                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterDropdownItems: ['Open','Release','Applied'],
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            metric_type_value: false,
            loading:false,
            canUpdate:false,
            canAdd:false,
            lockbox:'',
            selectedFile:'',
            pageKey:"_receipt_list_",
            action:'list',
            receiptArr:[],
            receipt:'',
            receiptErrorMsg:'',
            errorMsg:'',
            fileName:'',
            file:'',
            lockFileName:'',
            selectFile:'',
            lockfile:'',
            checkFile: '',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_payment_receipt') {
                            self.cantAccessPage = true;
                        }

                        if (permissions[i].name == 'add_payment_receipt') {
                            self.canAdd = true;
                            self.canUpdate = true;
                        }
                    }
                }

            },

            lockbox: function(lockbox) {
              var self = this;
              console.log("lockbox ==", lockbox);
              console.log("lockbox ==", self.lockbox);

              console.log("checkFile == ", self.checkFile);

              if(self.checkFile !== '') {

                console.log("FILE-1 == ", self.checkFile)



                var type = self.checkFile.type;
                console.log(type);
                if(self.lockbox === true) {
                  $('#typeImage').attr("accept", ".csv, text/csv")
                  console.log("type ==", type);
                  if(type === 'text/csv') {

                      self.errorMsg = "";
                      console.log("CSV avialable");
                    } else {
                      var extention = self.checkFile.name.split('.').pop();
                      self.errorMsg = extention + " is not supporter file type, please select CSV";
                      console.log("no csv");
                    }

                } else {
                  console.log("COME ELESE");
                  $('#typeImage').attr("accept", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel")
                  if(type === 'application/vnd.ms-excel'
                    || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
                    || type === 'application/vnd.ms-excel.sheet.macroEnabled.12' || type === 'application/vnd.ms-excel.template.macroEnabled.12'
                    || type === 'application/vnd.ms-excel.addin.macroEnabled.12' || type === 'application/vnd.ms-excel.sheet.binary.macroEnabled.12') {
                      self.errorMsg = "";
                    } else {
                      var extention = self.checkFile.name.split('.').pop();
                      self.errorMsg = extention + " is not supporter file type, please select excel";
                    }
                }

              }


            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
            this.loadFieldData(['receipt']);
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listReceiptTable.unselectAllInternal();
            },
            exportReports: function() {
                var self = this;
                this.action = "export";
                this.loadList();
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            loadList() {
                var self = this;
                var selectedRows = [];

                //because on first load list not initialize
                var data = self.$refs['listReceiptTable'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(self.$refs['listReceiptTable'].selectedRows[i].id)
                }

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action:self.action,
                    selectedRows:selectedRows,
                    selectedAll:self.serverParams.selectedAll
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/receipt/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                             if ( self.action == "export" ) {

                                self.action = "list";
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {

                                    self.excel = data.content.web;
                                    var save = document.createElement("a");
                                    save.href = self.excel;
                                    save.download = data.content.web;
                                    save.target = "_blank";

                                    document.body.appendChild(save);
                                    save.click();
                                    document.body.removeChild(save);
                                    self.cancelAll(true);
                                    EventBus.$emit("clear-all-flags", false);

                                }
                                self.loadList();
                            }else{
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'news-list');
                    }
                });
            },
            onFileChanged (event) {
                const file = event.target.files[0]
                console.log(event.target);
                var self = this;

                self.checkFile = file;


                var type = file.type;
                console.log("file = ", type);
                if(self.lockbox == true) {
                  if(type === 'text/csv') {
                    console.log("its CSV ");
                    self.errorMsg = "";
                    self.selectedFile = file;
                    // self.notfound = false;
                    // self.notFoundArr = [];
                    console.log(self.selectedFile);
                  } else {
                    console.log("NOT CSV ");
                    var extention = file.name.split('.').pop();
                    self.errorMsg = extention + " is not supporter file type, please select CSV";
                  }
                } else {
                  if(type === 'application/vnd.ms-excel'
                  || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
                  || type === 'application/vnd.ms-excel.sheet.macroEnabled.12' || type === 'application/vnd.ms-excel.template.macroEnabled.12'
                  || type === 'application/vnd.ms-excel.addin.macroEnabled.12' || type === 'application/vnd.ms-excel.sheet.binary.macroEnabled.12') {
                    self.errorMsg = "";
                    self.selectedFile = file;

                    console.log("its excel");
                    // self.notfound = false;
                    // self.notFoundArr = [];
                    console.log(self.selectedFile);
                  } else {
                    console.log("not excel");
                    var extention = file.name.split('.').pop();
                    self.errorMsg = extention + " is not supporter file type, please select excel";
                  }
                }
            },
            openModal: function(){
                var self = this;
                // $('#myButton').text('Import');
                // self.notFoundArr = [];
                self.selectedFile = "";
                // self.notfound = false;
                self.error = "";
                // $("#typeImage").val('');
                self.lockbox = false;
                self.receipt = '';
                // id="typeImage"
                $('#typeImage').attr("accept", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel")

                self.generateExcelSample();
                $('#receiptModal').modal('show');
            },
            generateExcelSample:function(){
                var self = this;

                $.ajax({
                    url:
                    process.env.ROOT_API +
                    "/receipt-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        self.loading = false;
                        self.fileName = data.content.file;
                        self.selectFile = self.fileName;
                        self.file = data.content.web;
                        self.lockfile = data.content.lock_web;
                        self.lockFileName = data.content.lock_file;
                        console.log("lock ==", self.lockFileName);

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'telematics-reading-import')

                    }
                });
            },
            importReport: function(){
                var self = this;
                self.errorMsg = "";
                self.receiptErrorMsg = '';
                if(self.selectedFile == "" || self.selectedFile == null){
                    self.error = "Please Select Excel File.";
                    return;
                }else{
                    self.error = "";
                }
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);
                formData.append('lockbox', self.lockbox);

                if (self.lockbox == true && (self.receipt == null || !self.receipt.value)){
                    self.receiptErrorMsg = 'Please select receipt';
                    return;
                }
                if (self.receipt != null && self.receipt.value){
                    formData.append('receipt', self.receipt.value);
                }


                self.loading = true;
                $('#myButton').text('Fetching...');
                $('#myButton').prop('disabled',true);
                $.ajax({
                url: process.env.ROOT_API + "/receipt/import",
                type: "POST",
                // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    $('#myButton').text('Import');
                    $('#myButton').prop('disabled',false);
                    self.loading = false;
                    if(data.code == 201){
                        self.error = data.message;
                        self.$swal('',data.message,'info');
                        return;
                    }
                    if (data.status == "success") {
                        self.error = "";
                        if(data.content.length > 0){
                            // self.notfound = true;
                             $('#myButton').text('OK');
                            // self.notFoundArr = data.content;
                        }else{
                            $('#receiptModal').modal('hide');
                            self.loadList();
                        }

                    }
                },
                error: function (jqXHR, exception) {
                  console.log("ERROR =", jqXHR.status);
                  console.log("ERROR =", jqXHR);
                  console.log("ERROR =", exception);
                    $('#myButton').text('Import');
                    $('#myButton').prop('disabled',false);
                   self.loading = false;
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else if(jqXHR.status == 400) {
                      if(jqXHR.responseJSON.content.includes("sheet name [Details]")) {
                        self.errorMsg = "Invalid format of file";
                      } else {
                        self.errorMsg = jqXHR.responseJSON.content;
                      }

                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                    }
                }
            });
            },
            downloadSample(){
                var self = this;
                // alert(self.file);

                if (self.lockbox){
                    var docPath = self.lockfile;
                }else{
                    var docPath = self.file;
                }
                console.log("new =", docPath);
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            changeLockCheck:function(evt){
                var self = this;
                if (evt.target.checked === true){
                    self.selectFile = self.lockFileName;

                }else{
                    self.selectFile = self.fileName;

                }
            }
        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/ReceiptList.vue